// import { createContext, useContext, useEffect, useReducer } from "react";
// import { jwtDecode } from "jwt-decode";

// //  Initial State
// const initialState = {
//   user: null,
//   loading: false,
//   data: [], // Master data will go here
// };

// //  Reducer
// const appReducer = (state, action) => {
//   switch (action.type) {
//     case "SET_USER":
//       return { ...state, user: action.payload };
//     case "SET_LOADING":
//       return { ...state, loading: action.payload };
//     case "SET_DATA":
//       return { ...state, data: action.payload };
//     default:
//       return state;
//   }
// };

// //  Create Context
// const AppContext = createContext();

// //  Provider
// export const AppProvider = ({ children }) => {
//   const [state, dispatch] = useReducer(appReducer, initialState);

//   useEffect(() => {
//     // Read token from localStorage or sessionStorage
//     const token = localStorage.getItem("accessToken"); // or sessionStorage.getItem("token")

//     if (token) {
//       try {
//         const decoded = jwtDecode(token);
//         // console.log("Decoded",decoded)
//         dispatch({ type: "SET_USER", payload: decoded });
//       } catch (err) {
//         console.error("Invalid token:", err);
//         // Optionally remove invalid token
//         localStorage.removeItem("token");
//       }
//     }
//   }, []);

//   return (
//     <AppContext.Provider value={{ state, dispatch }}>
//       {children}
//     </AppContext.Provider>
//   );
// };

import { createContext, useContext, useEffect, useReducer } from "react";
import { jwtDecode } from "jwt-decode";
import { getNewAccessToken } from "../utils/authUtils"; // Ensure correct path

// Initial State
const initialState = {
  user: null,
  loading: true, // start as loading until tokens are checked
  data: [], // Master data placeholder
};

// Reducer
const appReducer = (state, action) => {
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.payload };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_DATA":
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

// Create Context
const AppContext = createContext();

// Provider
export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  useEffect(() => {
    const checkTokens = async () => {
      const accessToken = localStorage.getItem("accessToken");
      const refreshToken = localStorage.getItem("refreshToken");

      // 1️ Check access token
      if (accessToken) {
        try {
          const decoded = jwtDecode(accessToken);
          const now = Date.now() / 1000;

          if (decoded.exp && decoded.exp > now) {
            // Access token valid
            dispatch({ type: "SET_USER", payload: decoded });
            dispatch({ type: "SET_LOADING", payload: false });
            return;
          }
        } catch (err) {
          console.error("Access token decode error:", err);
        }
      }

      // 2️ If access token missing/expired, try refresh token
      if (refreshToken) {
        // console.log("inside refresh")
        const newAccessToken = await getNewAccessToken();

        // console.log("New Access Token",newAccessToken)
        if (newAccessToken) {
          try {
            const decoded = jwtDecode(newAccessToken);
            dispatch({ type: "SET_USER", payload: decoded });
          } catch (err) {
            console.error("New access token decode failed:", err);
            dispatch({ type: "SET_USER", payload: null });
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
          }
        } else {
          // Refresh token invalid → log out
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          dispatch({ type: "SET_USER", payload: null });
        }
      } else {
        // No tokens at all → user not logged in
        dispatch({ type: "SET_USER", payload: null });
      }

      // Done checking → stop loading
      dispatch({ type: "SET_LOADING", payload: false });
    };

    checkTokens();
  }, []);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

// Custom Hook
export const useAppContext = () => useContext(AppContext);
